/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Button, Space, Table, message, Modal, Popconfirm, Drawer, Form, Select } from "antd";
import { EditOutlined, EyeOutlined, SyncOutlined } from "@ant-design/icons";
// import { useNavigate } from "react-router-dom";
// import Map from "../Map";
import MasterModal from "../../../../components/Master/Modal";
import UploadDrawer from "../../PincodeMaster/uploadDrawer";
import AddNewRoute from "./AddNewRoute";
import upload_pin_icon from "../../../../assests/images/SVG/upload-pin-icon.svg";
import download_pin_icon from "../../../../assests/images/SVG/download-pin.svg";
import print_logo from "../../../../assests/images/SVG/master-print.svg";
import "../../PacketingGuide/style.scss";
import axios from "axios";
import { APIs, getPremiseId } from "../../../../utils/worker";
import NormalAPI from "../../../../api";
import urls from "../../../../api/urls";
import { capitalize, capitaliseWithHyphen } from "../../../../utils";
import constants from "../../../../constants/constants";
import { ReactComponent as Disable_icon } from "../../../../assests/images/SVG/disable.svg";
import ViewVehicleRoute from "./viewRoute";
import EditVehicleRoute from "./EditVehicleRoute";
export let hubListWithMode = null;

export const setHubListWithMode = (value) => {
  hubListWithMode = value;
};

export const getHubListWithMode = () => hubListWithMode;

const {
  CREATE_ROUTE,
  GET_ALL_ROUTE,
  GET_ALL_V_ROUTE,
  CREATE_V_ROUTE,
  DELETE_V_ROUTE,
  GET_HUB_LISTS,
  UPDATE_V_ROUTE,
  UPLOAD_VEHICLE_ROUTE
} = urls;
const { ROLES } = constants;
const { HO_ADMIN, HUB_ADMIN, DEVELOPER, ROLE_CENTRALOPERATOR, ROLE_FUNCTIONALHEAD, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM } = ROLES;

const RouteTable = ({ primaryMode }) => {
  //   const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [userToken, setUserToken] = useState("");
  const [scale, setScale] = useState(376);
  const [height, setHeight] = useState(220);
  const [width, setWidth] = useState("95%");
  const [tableDataSource, setDataSource] = useState([]);
  const [mapData, setMapData] = useState([]);
  const [mapDataParent, setMapDataParent] = useState([]);
  const [totalPageSize, setTotalPageSize] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [pageNum, setPageNum] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isMapModalVisible, setIsMapModalVisible] = useState(false);
  const [roles, setRoles] = useState();
  const url = "/vehicle-route-service/v1/upload";
  const sampleUrl = "/route-service/v1/sample/" + primaryMode;
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [viewRouteData, setViewRouteData] = useState(null);
  const [drawerWidth, setDrawerWidth] = useState(900);
  const [allRouteData, setAllRouteData] = useState(null);
  const [hubListDropdown, setHubListDropdown] = useState(null);
  const [originSearch, setOriginSearch] = useState(null);
  const [destinationSearch, setDestinationSearch] = useState(null);
  const [viewFlag, setViewFlag] = useState(true);
  const [form] = Form.useForm();
  const [orginHubId, setOrginHubId] = useState(-1);
  useEffect(() => {
    setRoles(JSON.parse(localStorage.getItem("userinfo")));
    getHubLists();
  }, []);
  const removeSeconds = (dateTime) => {
    if (!dateTime) return "";

    return dateTime.replace(/:\d{2}$/, "");
  };
  const tableLoading = {
    spinning: isTableLoading,
    indicator: <SyncOutlined spin />,
  };
  const actionColumn =
    roles && (roles?.roles?.includes(HO_ADMIN) || roles?.roles?.includes(DEVELOPER))
      ? {
        title: "Action",
        key: "operation",
        fixed: "right",
        width: 100,
        dataIndex: "",
        sorter: false,
        sortOrder: null,
        ellipsis: true,
        render: (_, data) => (
          <div className="action-column">

            <Popconfirm
              title="Disable route"
              description="Are you sure to disable this route?"
              onConfirm={() => deleteRoute(data)}
              okText="Yes"
              cancelText="No"
              disabled={!data?.active}
            >
              <Disable_icon
                style={{ cursor: data?.active ? "pointer" : "not-allowed" }}
              />
            </Popconfirm>
            <EyeOutlined
              className={`action-icon ${data?.active ? "active" : "disabled"}`}
              onClick={() => {
                setIsViewModalOpen((prev) => !prev);
                filterViewData(data.id);
              }}
            />
          </div>
        ),
      }
      : {
        title: "Action",
        key: "operation",
        fixed: "right",
        width: 100,
        dataIndex: "",
        sorter: false,
        sortOrder: null,
        ellipsis: true,
        render: (_, data) => (
          <div className="action-column">

            {/* <Popconfirm
              title="Disable route"
              description="Are you sure to disable this route?"
              onConfirm={() => deleteRoute(data)}
              okText="Yes"
              cancelText="No"
              disabled={!data?.active}
            >
              <Disable_icon
                style={{ cursor: data?.active ? "pointer" : "not-allowed" }}
              />
            </Popconfirm> */}
            <EyeOutlined
              className={`action-icon ${data?.active ? "active" : "disabled"}`}
              onClick={() => {
                setIsViewModalOpen((prev) => !prev);
                filterViewData(data.id);
                // handleEditClickRoute(record);
              }}
            />
          </div>
        ),
      };
  const columns = [
    {
      title: "Updated Date",
      dataIndex: "updatedDate",
      key: "updatedDate",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Origin Hub",
      dataIndex: "origin",
      key: "origin",
      render: (text) => <span>{capitaliseWithHyphen(text)}</span>,
    },
    {
      title: "Destination Hub",
      dataIndex: "destination",
      key: "destination",
      render: (text) => <span>{capitaliseWithHyphen(text)}</span>,
    },
    {
      title: "Transit 1",
      dataIndex: "transit1",
      key: "transit1",
    },
    {
      title: "Transit 2",
      dataIndex: "transit2",
      key: "transit2",
    },
    {
      title: "Transit 3",
      dataIndex: "transit3",
      key: "transit3",
    },
    {
      title: "Transit 4",
      dataIndex: "transit4",
      key: "transit4",
    },
    {
      title: "Transit 5",
      dataIndex: "transit5",
      key: "transit5",
    },
    {
      title: "Transit 6",
      dataIndex: "transit6",
      key: "transit6",
    },
    {
      title: "Transit 7",
      dataIndex: "transit7",
      key: "transit7",
    },
    actionColumn,
  ];

  useEffect(() => {
    let userData = JSON.parse(localStorage.getItem("userinfo"));
    setUserToken(userData.accessToken);
    getRouteList("?pageNum=0&pageSize=10");
  }, []);

  const getRouteList = async (page) => {
    setIsTableLoading(true);
    try {
      let response = null;
      let activeHub = JSON.parse(localStorage.getItem("active_hub") || "{}");
      let userInfo = JSON.parse(localStorage.getItem("userId") || "{}");
      let currentPremiseId = activeHub?.hubId || userInfo?.userInfo?.premiseId;
      let userId = userInfo?.userId || JSON.parse(localStorage.getItem("userinfo"))?.userId;

      const headers = {
        "SMCS-PREMISE-ID": String(currentPremiseId),
        "USER-ID": userId
      };

      if (
        JSON.parse(localStorage.getItem("userinfo"))?.roles?.includes(HO_ADMIN) || JSON.parse(localStorage.getItem("userinfo"))?.roles?.includes(DEVELOPER)
      ) {
        // console.log("GET_ALL_V_ROUTE HO_ADMIN", GET_ALL_V_ROUTE + primaryMode + page);
        response = await NormalAPI.Api(
          GET_ALL_V_ROUTE + primaryMode + page
        ).getCustomHeader(headers);
      } else {
        // console.log("GET_ALL_V_ROUTE NOT_HO_ADMIN", JSON.parse(localStorage.getItem("userinfo")));
        response = await NormalAPI.Api(
          GET_ALL_V_ROUTE + primaryMode + page
        ).getCustomHeader(headers);
      }
      let temp = [];
      setTotalPageSize(response?.response?.data?.totalCounts);
      setAllRouteData(response?.response?.data?.data);

      // Ensure pagination state is always valid
      if (response?.response?.data?.totalCounts === 0 || response?.response?.data?.totalCounts === null || response?.response?.data?.totalCounts === undefined) {
        setCurrentPage(1);
        setPageNum(0);
        setPageSize(10);
      }

      // Ensure data exists before processing
      if (response?.response?.data?.data && Array.isArray(response?.response?.data?.data)) {
        response?.response?.data?.data.map((item) => {
          if (item.route.length > 0) {
            temp.push({
              id: item.routeId,
              active: item?.active,
              updatedDate: item?.updatedDate,
              origin: capitalize(item.route[0].hubName),
              destination: capitalize(item.route[item.route.length - 1].hubName),
              transit1:
                item.route.length > 2
                  ? capitalize(item.route[1].hubName)
                  : "------",
              transit2:
                item.route.length > 3
                  ? capitalize(item.route[2].hubName)
                  : "------",
              transit3:
                item.route.length > 4
                  ? capitalize(item.route[3].hubName)
                  : "------",
              transit4:
                item.route.length > 5
                  ? capitalize(item.route[4].hubName)
                  : "------",
              transit5:
                item.route.length > 6
                  ? capitalize(item.route[5].hubName)
                  : "------",
              transit6:
                item.route.length > 7
                  ? capitalize(item.route[6].hubName)
                  : "------",
              transit7:
                item.route.length > 8
                  ? capitalize(item.route[7].hubName)
                  : "------",
            });
          }
        });
      }
      setDataSource(temp);
      setMapData(response?.response?.data?.data);
      setMapDataParent(response?.response?.data?.data);
      setIsTableLoading(false);
    } catch (error) {
      if (error.response?.data?.message) message.error(error.response?.data?.message);
      setIsTableLoading(false);
    }
  };

  const deleteRoute = async (data) => {
    let response = await NormalAPI.Api(
      DELETE_V_ROUTE + data?.id
    ).deleteIdHeader();
    if (response?.status) {
      if (response?.response?.data?.message === "Route deleted successFully") {
        message.success(response?.response?.data?.message);
        getRouteList("?pageNum=0&pageSize=10");
      } else {
        message.error(response?.response?.data?.message);
      }

    }
  };

  const handlePageChange = (pagination) => {
    const newPage = pagination.current;
    const newPageSize = pagination.pageSize;

    setPageSize(newPageSize);
    setCurrentPage(newPage);
    setPageNum(newPage - 1); // Keep pageNum in sync with API (0-based)

    // Build query with proper page number (API expects 0-based)
    let query = `?pageNum=${newPage - 1}&pageSize=${newPageSize}`;

    // Preserve filters on pagination based on role
    const userInfo = JSON.parse(localStorage.getItem("userinfo"));
    const role = userInfo?.roles?.[0]?.replace(/.*_/, "");

    const activeHub = JSON.parse(localStorage.getItem("active_hub") || "{}");
    if (role === "HUBADMIN") {
      const premiseId = activeHub?.hubId || userInfo?.premiseId;
      if (premiseId) {
        query += `&fromHubId=${premiseId}`;
      }
      if (destinationSearch) {
        query += `&toHubId=${destinationSearch}`;
      }
    } else {
      if (originSearch) {
        query += `&fromHubId=${originSearch}`;
      }
      if (destinationSearch) {
        query += `&toHubId=${destinationSearch}`;
      }
    }
    getRouteList(query);
  };
  //need this code
  // const handlePageChange = () => {
  //   window.scrollTo(0, 0);
  // };

  // const itemRender = (_, type, originalElement) => {
  //   if (type === "prev") {
  //     return <a>Previous</a>;
  //   }
  //   if (type === "next") {
  //     return <a>Next</a>;
  //   }
  //   return <span>{originalElement}</span>;
  // };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setIsViewModalOpen(false);
  };

  const handleCreateRoute = async (values, formData, destinationTime) => {
    setLoading(true);
    let tempTransit = [];
    if (formData.length > 0) {
      formData.map((item, index) => {
        tempTransit.push({
          premise: formData[index].hub,
          travelBy:
            index === formData.length - 1
              ? values.destinationTransitMode
              : formData[index + 1].mode,
          transitTime:
            index === formData.length - 1
              ? destinationTime * 60
              : formData[index + 1].time * 60,
          distance:
            index === formData.length - 1
              ? +values.destinationTransitDistance
              : +formData[index + 1].distance,
        });
      });
    }
    let routeData = [
      {
        premise: values.originHub,
        travelBy:
          formData.length === 0
            ? values.destinationTransitMode
            : formData[0].mode,
        transitTime:
          formData.length === 0 ? destinationTime * 60 : formData[0].time * 60,
        distance:
          formData.length === 0
            ? +values.destinationTransitDistance
            : +formData[0].distance,
      },
      ...tempTransit,
      {
        premise: values.destinationHub,
      },
    ];
    let checkAir = routeData.some((e) => e.travelBy === "AIR");
    let routeKey =
      roles && (roles?.roles?.includes(HO_ADMIN) || roles?.roles?.includes(DEVELOPER)) ? "route" : "route";
    let payload = {
      name: values.originHub + "-" + values.destinationHub,
      routeType: values.primaryMode.toUpperCase(),
      [routeKey]: routeData,
    };
    if (primaryMode === "AIR") {
      if (checkAir) {
        submitData(payload, values.originHub, values.destinationHub);
      } else {
        message.error("Please select atleast one mode as AIR");
        setLoading(false);
      }
    } else {
      submitData(payload, values.originHub, values.destinationHub);
    }
  };
  const handleEditVehicleRoute = async (values, formData, destinationTime, route_id) => {
    setLoading(true);
    let tempTransit = [];
    if (formData.length > 0) {
      formData.map((item, index) => {
        tempTransit.push({
          position: index + 1,
          premise: formData[index].hub,
          travelBy:
            index === formData.length - 1
              ? values.destinationTransitMode
              : formData[index + 1].mode,
          transitTime:
            index === formData.length - 1
              ? destinationTime * 60
              : formData[index + 1].time * 60,
          distance:
            index === formData.length - 1
              ? +values.destinationTransitDistance
              : +formData[index + 1].distance,
        });
      });
    }
    let routeData = [
      {
        position: 0,
        premise: values.originHub,
        travelBy:
          formData.length === 0
            ? values.destinationTransitMode
            : formData[0].mode,
        transitTime:
          formData.length === 0 ? destinationTime * 60 : formData[0].time * 60,
        distance:
          formData.length === 0
            ? +values.destinationTransitDistance
            : +formData[0].distance,
      },
      ...tempTransit,
      {
        position: tempTransit.length > 0 ? tempTransit.length + 1 : 1,
        premise: values.destinationHub,
        travelBy:
          formData.length === 0
            ? values.destinationTransitMode
            : formData[0].mode,
        transitTime:
          formData.length === 0 ? destinationTime * 60 : formData[0].time * 60,
        distance:
          formData.length === 0
            ? +values.destinationTransitDistance
            : +formData[0].distance,
      },
    ];
    let checkAir = routeData.some((e) => e.travelBy === "AIR");
    let routeKey =
      roles && (roles?.roles?.includes(HO_ADMIN) || roles?.roles?.includes(DEVELOPER)) ? "route" : "route";
    let payload = {
      // name: values.originHub + "-" + values.destinationHub,
      routeType: values.primaryMode,
      [routeKey]: routeData,
    };
    if (primaryMode === "AIR") {
      if (checkAir) {
        submitEditData(payload, route_id);
      } else {
        message.error("Please select atleast one mode as AIR");
        setLoading(false);
      }
    } else {
      submitEditData(payload, route_id);
    }
  };

  const submitData = async (payload, originHub, destinationHub) => {
    let response = null;
    if (roles && (roles?.roles?.includes(HO_ADMIN) || roles?.roles?.includes(DEVELOPER))) {
      // response = await NormalAPI.Api(
      //   CREATE_ROUTE + `${originHub}/to/${destinationHub}`
      // ).postWithHeader(payload);
      response = await NormalAPI.Api(CREATE_V_ROUTE).postIdHeader(payload);
    } else {
      response = await NormalAPI.Api(CREATE_V_ROUTE).postIdHeader(payload);
    }
    if (response.status) {
      message.success(response?.data?.message || "Route Created Successfully");
      setLoading(false);
      setIsModalOpen(false);
      setCurrentPage(1);
      getRouteList("?pageNum=0&pageSize=10");
    } else {
      message.error(response.response.data.message);
      setLoading(false);
    }
  };

  const handleCallBack = () => {
    getRouteList("?pageNum=0&pageSize=10");
  };

  const goFull = (id) => {
    const target = document.getElementById("fullscreen-target-" + id);
    target.addEventListener("click", (e) => {
      setScale(550);
      setHeight(365);
      setWidth("calc(180% - 120px)");
      setIsMapModalVisible(true);
      // e.currentTarget?.requestFullscreen();
    });
  };
  const goClose = () => {
    document.webkitExitFullscreen();
    setScale(376);
    setHeight(220);
    setWidth("95%");
    setIsMapModalVisible(false);
  };
  const downloadAllRoute = () => {
    let userinfo = JSON.parse(localStorage.getItem("userinfo"));
    const getRole = userinfo?.roles[0]?.replace(/.*_/, "");
    const premiseId = getPremiseId();
    const id = premiseId.split("Bearer ")[1];
    if (getRole === "HOADMIN" || getRole === "CENTRALOPERATOR" || getRole === "FUNCTIONALHEAD" || getRole === "ZONALHEAD" || getRole === "ZONALOPERATOR" || getRole == "DEVELOPER" || getRole === "HOCRM") {
      if (orginHubId !== -1) {
        if (destinationSearch) {
          window.open(
            APIs.baseURL +
            `/vehicle-route-service/v2/download/${primaryMode}/premise?scope=${"HUB"}&sourcePremiseId=${orginHubId}&destinationPremiseId=${destinationSearch}`
          );
        } else {
          window.open(
            APIs.baseURL +
            `/vehicle-route-service/v2/download/${primaryMode}/premise?scope=${"HUB"}&sourcePremiseId=${orginHubId}`
          );
        }
      } else {
        if (destinationSearch) {
          window.open(
            APIs.baseURL +
            `/vehicle-route-service/v2/download/${primaryMode}/premise?scope=${"HUB"}&destinationPremiseId=${destinationSearch}`
          );
        } else {
          window.open(
            APIs.baseURL +
            `/vehicle-route-service/v2/download/${primaryMode}/premise?scope=${"HO"}`
          );
        }

      }

    } else if (getRole === "HUBADMIN") {
      if (destinationSearch) {
        window.open(
          APIs.baseURL +
          `/vehicle-route-service/v2/download/${primaryMode}/premise?scope=${"HUB"}&sourcePremiseId=${id}&destinationPremiseId=${destinationSearch}`
        );
      } else {
        window.open(
          APIs.baseURL +
          `/vehicle-route-service/v2/download/${primaryMode}/premise?scope=${"HUB"}&sourcePremiseId=${id}`
        );
      }
    }

  };


  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  const handleClose = () => {
    setDrawerOpen(false);
  };
  const handleViewModal = () => {
    setIsViewModalOpen(false);
  };
  const filterViewData = (id) => {
    let temp = allRouteData?.filter(a => a.routeId == id);
    setViewRouteData(temp);
    setViewFlag(true);
  };

  const getHubLists = async (params) => {
    setIsTableLoading(true);

    let response = await NormalAPI.Api(GET_HUB_LISTS).getWithHeader();
    if (response.status) {
      let temp = response?.response?.data;
      setHubListWithMode(temp);

      temp = temp?.map((val) => {
        return {
          label: capitalize(val?.premiseName),
          value: val?.premiseId,
        };
      });

      /* tempMode = tempMode?.map((val) => {
        return {
          label: val?.premiseId,
          value: val?.hubMode,
        };
      });*/
      setHubListDropdown(temp);
    } else {
      setHubListDropdown([]);
      // console.log("error");
    }
  };
  function handleOriginSearch(params) {
    setOriginSearch(params);
    setCurrentPage(1); // Reset to first page when searching
    setPageNum(0);     // Reset pageNum to match API expectation
    setPageSize(10);   // Ensure consistent page size
    setOrginHubId(params);
    let query = "?pageNum=0&pageSize=10";
    query += `&fromHubId=${params}`;
    // If destination is already selected (HOADMIN flow), keep it in the filter
    if (destinationSearch) {
      query += `&toHubId=${destinationSearch}`;
    }
    getRouteList(query);
  }
  function handleDestinationSearch(params) {
    setDestinationSearch(params);
    setCurrentPage(1); // Reset to first page when searching
    setPageNum(0);     // Reset pageNum to match API expectation
    setPageSize(10);   // Ensure consistent page size

    let query = "?pageNum=0&pageSize=10";
    const userInfo = JSON.parse(localStorage.getItem("userinfo"));
    const role = userInfo?.roles?.[0]?.replace(/.*_/, "");

    if (role === "HUBADMIN") {
      const activeHub = JSON.parse(localStorage.getItem("active_hub") || "{}");
      const premiseId = activeHub?.hubId || userInfo?.premiseId;
      setOrginHubId(premiseId);
      if (premiseId) {
        query += `&fromHubId=${premiseId}`;
      }
    } else {
      if (originSearch) {
        query += `&fromHubId=${originSearch}`;
      }
    }

    query += `&toHubId=${params}`;
    getRouteList(query);
  }
  const handleOriginSelectClear = () => {
    const userInfo = JSON.parse(localStorage.getItem("userinfo"));
    const role = userInfo?.roles?.[0]?.replace(/.*_/, "");
    setCurrentPage(1);
    setPageNum(0);
    setPageSize(10);

    if (role === "HUBADMIN") {
      // For HUBADMIN, the left select is actually Destination; revert to only origin (premise)
      setDestinationSearch(null);
      let query = "?pageNum=0&pageSize=10";
      const activeHub = JSON.parse(localStorage.getItem("active_hub") || "{}");
      const premiseId = activeHub?.hubId || userInfo?.premiseId;
      if (premiseId) query += `&fromHubId=${premiseId}`;
      getRouteList(query);
    } else {
      // For HOADMIN, clearing origin should search based on destination if set
      setOriginSearch(null);
      let query = "?pageNum=0&pageSize=10";
      if (destinationSearch) query += `&toHubId=${destinationSearch}`;
      getRouteList(query);
    }
  };

  const handleDestinationSelectClear = () => {
    const userInfo = JSON.parse(localStorage.getItem("userinfo"));
    const role = userInfo?.roles?.[0]?.replace(/.*_/, "");
    setCurrentPage(1);
    setPageNum(0);
    setPageSize(10);

    if (role === "HUBADMIN") {
      // Only destination exists; keep origin fixed and remove destination
      setDestinationSearch(null);
      let query = "?pageNum=0&pageSize=10";
      const activeHub = JSON.parse(localStorage.getItem("active_hub") || "{}");
      const premiseId = activeHub?.hubId || userInfo?.premiseId;
      if (premiseId) query += `&fromHubId=${premiseId}`;
      getRouteList(query);
    } else {
      // For HOADMIN, clearing destination should search based on origin if set
      setDestinationSearch(null);
      let query = "?pageNum=0&pageSize=10";
      if (originSearch) query += `&fromHubId=${originSearch}`;
      getRouteList(query);
    }
  };
  const handleOriginClear = () => {

    setOriginSearch(null);
    setDestinationSearch(null);
    setCurrentPage(1);  // Reset to first page
    setPageNum(0);      // Reset pageNum to match API expectation
    setPageSize(10);    // Reset to default page size

    let queryParams = "?pageNum=0&pageSize=10";
    getRouteList(queryParams);
  };
  const submitEditData = async (payload, id) => {
    let response = null;
    if (roles && (roles?.roles?.includes(HO_ADMIN) || roles?.roles?.includes(DEVELOPER))) {
      response = await NormalAPI.Api(UPDATE_V_ROUTE + id).putIdHeader(payload);
    }
    if (response.status) {
      message.success(response?.data?.message || "Route Update Successfully");
      setLoading(false);
      setIsModalOpen(false);
      setIsViewModalOpen(false);
      setCurrentPage(1);
      getRouteList("?pageNum=0&pageSize=10");
    } else {
      message.error(response.response.data.message);
      setLoading(false);
    }
  };
  return (
    <div className="master-main-container" style={{ paddingBottom: "1rem" }}>
      <div
        className={roles && (roles?.roles?.includes(HO_ADMIN) || roles?.roles?.includes(DEVELOPER)) ? "master-main-container" : ""}
        style={{ marginTop: "1rem" }}
      >
        <div className="p-1 space-between" style={{ flexWrap: "wrap" }}>
          <div className="">
            {
              (
                <Form
                  form={form}
                  className="d-flex global-form"
                  style={{ alignItems: "center" }}
                >
                  <div className="global-form-row d-flex">
                    <div style={{ marginRight: "15px" }}>
                      <span>{JSON.parse(localStorage.getItem("userinfo"))?.roles?.[0]?.replace(/.*_/, "") === "HUBADMIN" ? "Destination" : "Origin"}</span>
                      <>
                        <Form.Item name={"originHub"}>
                          <Select
                            showSearch
                            style={{
                              width: "275px",
                            }}
                            allowClear
                            onClear={handleOriginSelectClear}
                            onSearch={() => { }}
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            placeholder={JSON.parse(localStorage.getItem("userinfo"))?.roles?.[0]?.replace(/.*_/, "") === "HUBADMIN" ? "Search destination" : "Search origin"}
                            options={hubListDropdown}
                            onSelect={(data) => JSON.parse(localStorage.getItem("userinfo"))?.roles?.[0]?.replace(/.*_/, "") === "HUBADMIN" ? handleDestinationSearch(data, "destinationHub") : handleOriginSearch(data, "originHub")}
                          />
                        </Form.Item>
                      </>
                    </div>
                    {(roles?.roles?.includes(HO_ADMIN) || roles?.roles?.includes(DEVELOPER) || roles?.roles?.includes(ROLE_FUNCTIONALHEAD) || roles?.roles?.includes(ROLE_ZONALHEAD) || roles?.roles?.includes(ROLE_ZONALOPERATOR)) && (
                      <div style={{ marginRight: "10px" }}>
                        <span>Destination</span>
                        <>
                          <Form.Item name={"destinationHub"}>
                            <Select
                              showSearch
                              style={{ width: "275px" }}
                              allowClear
                              onClear={handleDestinationSelectClear}
                              onSearch={() => { }}
                              filterOption={(input, option) =>
                                (option?.label ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              placeholder={"Search destination"}
                              options={hubListDropdown}
                              onSelect={(data) => handleDestinationSearch(data, "destinationHub")}
                            />
                          </Form.Item>
                        </>
                      </div>
                    )}
                  </div>

                  <div>
                    <Button
                      className="cancel-btn ml-1"
                      style={{ marginTop: "5px" }}
                      onClick={() => {
                        setOrginHubId(-1);
                        setOriginSearch(null);
                        setDestinationSearch(null);
                        form.resetFields();
                        setCurrentPage(1);
                        setPageNum(0);
                        setPageSize(10);
                        getRouteList("?pageNum=0&pageSize=10");
                      }}
                      disabled={!originSearch && !destinationSearch}
                    >
                      CLEAR
                    </Button>
                  </div>
                </Form>
              )}

          </div>

          <div className="d-flex">
            {roles?.roles?.includes(HO_ADMIN) || roles?.roles?.includes(DEVELOPER) ? (
              <>
                <Button
                  className="cancel-btn"
                  onClick={() => setDrawerOpen(true)}
                >
                  <img src={upload_pin_icon} alt="upload button" />
                  &nbsp;UPLOAD
                </Button>
                <Button className="cancel-btn ml-1" onClick={downloadAllRoute}>
                  <img src={download_pin_icon} alt="download logo" />
                  &nbsp;DOWNLOAD
                </Button>

                <Button
                  className="save-btn ml-1"
                  onClick={() => setIsModalOpen(true)}
                >
                  CREATE NEW ROUTE
                </Button>
              </>
            ) : (roles?.roles?.includes(HUB_ADMIN) ||
              roles?.roles?.includes(DEVELOPER) ||
              roles?.roles?.includes(ROLE_CENTRALOPERATOR) ||
              roles?.roles?.includes(ROLE_FUNCTIONALHEAD) ||
              roles?.roles?.includes(ROLE_ZONALHEAD) ||
              roles?.roles?.includes(ROLE_ZONALOPERATOR)) ? (
              <>
                <Button className="cancel-btn ml-1" onClick={downloadAllRoute}>
                  <img src={download_pin_icon} alt="download logo" />
                  &nbsp;DOWNLOAD
                </Button>
              </>
            ) : null}
          </div>
        </div>
        <Table
          className="table-head-sticky"
          columns={columns}
          dataSource={tableDataSource}
          loading={tableLoading}
          onRow={(record) => ({
            style: {
              background: record?.active === false ? "#E2E2E2" : "white",
            },
          })}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalPageSize,
            itemRender: itemRender,
          }}
          onChange={handlePageChange}
          scroll={{
            x: 1700,
          }}
        />
      </div>
      <MasterModal
        title="Create New Route"
        content={
          <AddNewRoute
            handleCreateRoute={handleCreateRoute}
            handleCloseModal={handleCloseModal}
            primaryMode={primaryMode}
          />
        }
        visible={isModalOpen}
        width={1100}
        handleCloseModal={handleCloseModal}
        handleCreateRoute={handleCreateRoute}
        loading={loading}
      />
      <UploadDrawer
        title="Upload Vehicle Route"
        open={drawerOpen}
        onClose={handleClose}
        url={UPLOAD_VEHICLE_ROUTE}
        sampleUrl={sampleUrl}
        type={primaryMode === "AIR" ? "Vehicle Route Air" : "Vehicle Route Surface"}
        vehicleRouteType={primaryMode}
        handleCallBack={handleCallBack}
      />
      <Modal
        visible={isMapModalVisible}
        onCancel={goClose}
        footer={false}
        height={1000}
        width={1500}
        destroyOnClose
      ></Modal>
      {/* <Drawer
              title="View Route"
              visible={isViewModalOpen}
              onClose={handleViewModal}
              width={drawerWidth}
            >
            <ViewVehicleRoute
              recordData={viewRouteData}
              primaryMode={primaryMode}
            />
      </Drawer> */}
      {/* /////////////////////////// */}
      <Drawer
        title={viewFlag ? "View Route" : "Edit Route"}
        visible={isViewModalOpen}
        onClose={handleCloseModal}
        width={drawerWidth}
      >
        {(roles?.roles?.includes(HO_ADMIN) || roles?.roles?.includes(DEVELOPER)) && (
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              type="primary"
              className="save-btn"
              onClick={() => {
                setViewFlag((prev) => !prev), setViewRouteData(viewRouteData);
              }}
            >
              {viewFlag ? (
                <>
                  <EditOutlined
                    style={{ fontSize: 16, textDecoration: "none" }}
                  />{" "}
                  Edit{" "}
                </>
              ) : (
                <>
                  <EyeOutlined style={{ fontSize: 16 }} /> View
                </>
              )}
            </Button>
          </div>)}
        {/* for vehicle view edit base on condiction only for HO */}
        {viewFlag ? (
          <>
            {" "}
            <ViewVehicleRoute
              recordData={viewRouteData}
              primaryMode={primaryMode}
            />{" "}
          </>
        ) : (
          <>
            <EditVehicleRoute
              editRouteData={viewRouteData}
              handleEditRoute={handleEditVehicleRoute}
              handleCloseModal={handleCloseModal}
              primaryMode={primaryMode}
            />{" "}
          </>
        )}
      </Drawer>
      {/* //////////////////////////// */}
    </div>
  );
};

export default RouteTable;
